import { useEffect } from 'react';
import { useColorContext } from '../contexts/ColorContext';
import { useToolInit } from '../hooks/useToolInit';
import { ColorSpecSheet } from '../components/ColorSpecSheet';
import { PanelHeader } from '../components/shell/PanelHeader';
import { FileDown, ArrowUp } from 'lucide-react';

export function ExportTool() {
  const { params } = useToolInit();
  const { result, setInput, displayResult } = useColorContext();

  // Deep-link: ?color=<hex>
  useEffect(() => {
    if (params.color) {
      setInput(params.color);
    }
  }, [params.color, setInput]);

  if (!displayResult) {
    return (
      <>
        <PanelHeader title="Color Spec Sheet" subtitle="Export a complete color specification" />
        <div style={{
          textAlign: 'center', padding: 'var(--s-8) 0',
          color: 'var(--ink-3)', fontSize: 'var(--t-body)',
        }}>
          <FileDown style={{ width: 48, height: 48, margin: '0 auto var(--s-3)', opacity: 0.3 }} />
          <p style={{ fontWeight: 'var(--w-semi)' as unknown as number }}>No color selected</p>
          <p style={{ fontSize: 'var(--t-caption)', marginTop: 'var(--s-1)' }}>
            Enter a color in the top bar to generate a spec sheet
          </p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{
              marginTop: 'var(--s-3)',
              display: 'inline-flex', alignItems: 'center', gap: 'var(--s-1)',
              padding: 'var(--s-1) var(--s-3)',
              fontSize: 'var(--t-caption)', fontWeight: 600,
              color: 'var(--accent)', background: 'var(--accent-soft)',
              border: '1px solid transparent', borderRadius: 'var(--radius-lg)',
              cursor: 'pointer',
            }}
          >
            <ArrowUp size={12} /> Enter a color
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <PanelHeader
        title="Color Spec Sheet"
        subtitle={`Complete specification for ${displayResult.hex.toUpperCase()}`}
      />
      <ColorSpecSheet result={displayResult} />
    </>
  );
}
